import { create } from "zustand";

export type SyncState = "online" | "syncing" | "offline";

interface SyncStore {
  state: SyncState;
  lastSyncedAt: number;
  pendingChanges: number;
  setState: (state: SyncState) => void;
  queueChange: () => void;
  markSynced: () => void;
}

export const useSyncStore = create<SyncStore>((set) => ({
  state: typeof navigator !== "undefined" && !navigator.onLine ? "offline" : "online",
  lastSyncedAt: Date.now() - 3 * 60 * 1000,
  pendingChanges: 3,
  setState: (state) => set({ state }),
  queueChange: () => set((s) => ({ pendingChanges: s.pendingChanges + 1 })),
  markSynced: () => set({ state: "online", lastSyncedAt: Date.now(), pendingChanges: 0 }),
}));

export function syncLabel(state: SyncState): string {
  return state.toUpperCase();
}

export function relativeTime(from: number, now: number = Date.now()): string {
  const diff = Math.max(0, now - from);
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "just now";
  if (mins === 1) return "1 minute ago";
  if (mins < 60) return `${mins} minutes ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs === 1) return "1 hour ago";
  if (hrs < 24) return `${hrs} hours ago`;
  const days = Math.floor(hrs / 24);
  return days === 1 ? "1 day ago" : `${days} days ago`;
}
